import React from "react";
import { FormattedDate } from "react-intl";

interface IIntlDateTimeProps {
  value: any;
}

export default function IntlDateTime({ value }: IIntlDateTimeProps) {
  return <FormattedDate value={value} year="numeric" month="long" day="2-digit" />;
}

export function IntlDateTimeComment({ value }: IIntlDateTimeProps) {
  // old format date: "Y-m-d H:m"
  return <FormattedDate value={value} year="2-digit" month="numeric" day="numeric" hour="numeric" minute="numeric" />;
}
